import React from "react";

const PlanFeatures = ({ features = [] }) => {
  return (
    <div className="flex flex-col gap-4 text-left">
      {features.map((feature, idx) => (
        <p key={idx} className="text-gray-600 p-0 m-0">
          {feature.name}
        </p>
      ))}
    </div>
  );
};

export default PlanFeatures;
